import { VitalCardDifferencesModal } from './VitalCardDifferencesModal.component'
import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(VitalCardDifferencesModal)
export { withUnmountHoc as VitalCardDifferencesModal }
